'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _ClearableInput = require('components/ClearableInput/ClearableInput');

var _ClearableInput2 = _interopRequireDefault(_ClearableInput);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SearchBar.scss');

var SearchBar = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
  (0, _inherits3.default)(SearchBar, _PureComponent);

  function SearchBar() {
    (0, _classCallCheck3.default)(this, SearchBar);
    return (0, _possibleConstructorReturn3.default)(this, (SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(SearchBar, [{
    key: 'onChange',
    value: function onChange(kw) {
      this.filter(kw);
    }
  }, {
    key: 'filter',
    value: function filter(kw) {
      var _props = this.props,
          onSetFilter = _props.onSetFilter,
          onChange = _props.onChange;

      onSetFilter({ kw: kw });
      onChange(kw);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          className = _props2.className,
          inputClass = _props2.inputClass,
          kw = _props2.kw,
          title = _props2.title,
          autoFocus = _props2.autoFocus,
          delay = _props2.delay;

      var displayedTitle = title || t('Search');

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.container, className) },
        _react2.default.createElement(_ClearableInput2.default, {
          delay: delay,
          autoFocus: autoFocus,
          inputClassName: (0, _bind2.default)(styles.input, inputClass),
          title: displayedTitle,
          onChange: this.onChange,
          kw: kw,
          inputProps: { autoFocus: autoFocus }
        })
      );
    }
  }]);
  return SearchBar;
}(_react.PureComponent), _class3.propTypes = {
  autoFocus: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  inputClass: _propTypes2.default.string,
  kw: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onSetFilter: _propTypes2.default.func,
  t: _propTypes2.default.func,
  title: _propTypes2.default.string
}, _class3.defaultProps = {
  delay: 300,
  onChange: _noop3.default,
  onSetFilter: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class);
exports.default = SearchBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchBar/SearchBar.js
// module id = 183
// module chunks = 1